var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 13.3337V15.0003C8.33333 15.9208 9.07952 16.667 10 16.667H15.8333C16.7538 16.667 17.5 15.9208 17.5 15.0003V5.00033C17.5 4.07985 16.7538 3.33366 15.8333 3.33366H10C9.07952 3.33366 8.33333 4.07985 8.33333 5.00033V6.66699",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 9.25C2.91945 9.25 2.58366 9.58579 2.58366 10C2.58366 10.4142 2.91945 10.75 3.33366 10.75V9.25ZM14.167 10L14.6973 10.5303C14.9118 10.3158 14.976 9.99324 14.8599 9.71299C14.7438 9.43273 14.4703 9.25 14.167 9.25V10ZM11.1367 11.9697C10.8438 12.2626 10.8438 12.7374 11.1367 13.0303C11.4296 13.3232 11.9044 13.3232 12.1973 13.0303L11.1367 11.9697ZM12.1973 6.96967C11.9044 6.67678 11.4296 6.67678 11.1367 6.96967C10.8438 7.26256 10.8438 7.73744 11.1367 8.03033L12.1973 6.96967ZM13.6367 10.5303C13.9296 10.8232 14.4044 10.8232 14.6973 10.5303C14.9902 10.2374 14.9902 9.76256 14.6973 9.46967L13.6367 10.5303ZM3.33366 10.75H14.167V9.25H3.33366V10.75ZM13.6367 9.46967L11.1367 11.9697L12.1973 13.0303L14.6973 10.5303L13.6367 9.46967ZM11.1367 8.03033L13.6367 10.5303L14.6973 9.46967L12.1973 6.96967L11.1367 8.03033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.314c52ca26ffd2cfa46e820560bc52e9.svg";
export { ForwardRef as ReactComponent };